<template>
  <div class="log-container">
    <!-- 搜索区域 -->
    <div class="search-container">
      <div class="search-row">
        <div class="search-item">
          <label class="search-label">发生时间：</label>
          <input type="datetime-local" class="search-input" v-model="searchForm.startTime" />
          <span class="search-separator">~</span>
          <input type="datetime-local" class="search-input" v-model="searchForm.endTime" />
        </div>
        <div class="search-item">
          <label class="search-label">操作类型：</label>
          <select class="search-select" v-model="searchForm.type">
            <option value="">全部</option>
            <option value="login">登录</option>
            <option value="logout">退出</option>
            <option value="create">新建</option>
            <option value="modify">修改</option>
            <option value="remove">删除</option>
            <option value="query">查询</option>
            <option value="export">导出</option>
            <option value="import">导入</option>
          </select>
        </div>
        <div class="search-item">
          <label class="search-label">操作者：</label>
          <input type="text" class="search-input" v-model="searchForm.operator" placeholder="请输入操作者" />
        </div>
        <div class="search-item">
          <label class="search-label">操作模块：</label>
          <select class="search-select" v-model="searchForm.module">
            <option value="">全部</option>
            <option value="bigdata_home">大数据首页</option>
            <option value="data_decision">数据决策中心</option>
            <option value="price_supervision">价格动态监管</option>
            <option value="sentiment_monitor">全网舆情监测</option>
            <option value="customer_analysis">客群画像分析</option>
            <option value="business_resource">业态资源统筹</option>
            <option value="video_monitor">视频监测管理</option>
            <option value="capacity_monitor">承载力监测</option>
            <option value="user_manage">用户管理</option>
            <option value="role">角色配置</option>
            <option value="log">系统日志</option>
            <option value="system">系统操作</option>
          </select>
        </div>
        <div class="search-actions">
          <button class="btn-search" @click="searchLogs">
            <span>查询</span>
          </button>
          <button class="btn-reset" @click="resetSearch">
            <span>重置</span>
          </button>
        </div>
      </div>
    </div>

    <div class="table-container">
      <table class="data-table">
        <thead>
          <tr>
            <th style="width: 60px;">序号</th>
            <th style="width: 120px;">操作者</th>
            <th style="width: 100px;">操作类型</th>
            <th style="width: 120px;">操作模块</th>
            <th style="width: 220px;">事件描述</th>
            <th style="width: 140px;">关联对象</th>
            <th style="width: 160px;">发生时间</th>
            <th style="width: 120px;">来源IP</th>
            <th style="width: 100px;">执行状态</th>
            <th style="width: 100px;">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="log in filteredLogs" :key="log.id">
            <td>{{ log.id }}</td>
            <td>{{ log.operator }}</td>
            <td>{{ getTypeLabel(log.type) }}</td>
            <td>{{ getModuleLabel(log.module) }}</td>
            <td>{{ log.description }}</td>
            <td>{{ log.target }}</td>
            <td>{{ log.operationTime }}</td>
            <td>{{ log.ip }}</td>
            <td>{{ log.status === 'success' ? '成功' : '失败' }}</td>
            <td>
              <button class="btn-detail" @click="showLogDetail(log)">详情</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 分页 -->
    <div class="pagination-container">
      <div class="pagination-info">
        共 {{ totalLogs }} 条记录，当前显示第 {{ currentPage }} 页
      </div>
      <div class="pagination-buttons">
        <button class="btn-page" :disabled="currentPage === 1" @click="currentPage--">
          <span>上一页</span>
        </button>
        <span class="page-number">{{ currentPage }} / {{ totalPages }}</span>
        <button class="btn-page" :disabled="currentPage === totalPages" @click="currentPage++">
          <span>下一页</span>
        </button>
      </div>
    </div>

    <!-- 详情弹窗 -->
    <div class="detail-modal" v-if="showDetailModal">
      <div class="modal-overlay" @click="closeDetailModal"></div>
      <div class="modal-content detail-modal-content">
        <div class="modal-header">
          <div class="modal-title">日志详情</div>
          <button class="modal-close" @click="closeDetailModal">
            <span>×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="detail-info">
            <div class="detail-row">
              <span class="detail-label">事件ID：</span>
              <span class="detail-value">{{ selectedLog.id }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">操作者：</span>
              <span class="detail-value">{{ selectedLog.operator }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">操作类型：</span>
              <span class="detail-value">{{ getTypeLabel(selectedLog.type) }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">操作模块：</span>
              <span class="detail-value">{{ getModuleLabel(selectedLog.module) }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">事件描述：</span>
              <span class="detail-value">{{ selectedLog.description }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">关联对象：</span>
              <span class="detail-value">{{ selectedLog.target }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">发生时间：</span>
              <span class="detail-value">{{ selectedLog.operationTime }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">来源IP：</span>
              <span class="detail-value">{{ selectedLog.ip }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">执行状态：</span>
              <span class="detail-value">{{ selectedLog.status === 'success' ? '成功' : '失败' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">详细信息：</span>
              <span class="detail-value">{{ selectedLog.detail || '无' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">请求参数：</span>
              <span class="detail-value">{{ selectedLog.params || '无' }}</span>
            </div>
            <div class="compare-section" v-if="selectedLog.beforeData || selectedLog.afterData">
              <div class="compare-title">操作前后对比</div>
              <div class="compare-container">
                <div class="compare-column">
                  <div class="compare-header">操作前</div>
                  <div class="compare-content">{{ selectedLog.beforeData || '无' }}</div>
                </div>
                <div class="compare-arrow">→</div>
                <div class="compare-column">
                  <div class="compare-header">操作后</div>
                  <div class="compare-content">{{ selectedLog.afterData || '无' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-actions">
          <button class="btn-confirm" @click="closeDetailModal">关闭</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogManagement',
  data() {
    return {
      searchForm: {
        startTime: '',
        endTime: '',
        type: '',
        operator: '',
        module: ''
      },
      currentPage: 1,
      totalLogs: 0,
      showDetailModal: false,
      selectedLog: null,
      logs: [
        { id: 1, operator: '张伟', type: 'login', module: 'system', description: '用户登录系统', target: '账号: zhangwei', operationTime: '2026-06-12 09:30:00', ip: '192.168.1.100', status: 'success', detail: '用户通过用户名密码登录', params: '{username: "zhangwei"}' },
        { id: 2, operator: '张伟', type: 'create', module: 'user_manage', description: '新建用户账号', target: '用户: 李明', operationTime: '2026-06-12 09:35:00', ip: '192.168.1.100', status: 'success', detail: '成功创建新的用户账号', params: '{username: "liming", realName: "李明"}', beforeData: '无', afterData: '用户名：liming\n姓名：李明\n状态：启用\n创建时间：2026-06-12 09:35:00' },
        { id: 3, operator: '李丽', type: 'query', module: 'user_manage', description: '查询用户列表', target: '用户管理', operationTime: '2026-06-12 10:00:00', ip: '192.168.1.101', status: 'success', detail: '查询所有在职用户', params: '{status: "active"}' },
        { id: 4, operator: '张伟', type: 'modify', module: 'role', description: '修改角色权限', target: '角色: 普通员工', operationTime: '2026-06-12 10:30:00', ip: '192.168.1.100', status: 'success', detail: '更新角色权限配置', params: '{roleId: 3, permissions: [...]}', beforeData: '权限：查看、编辑', afterData: '权限：查看、编辑、删除' },
        { id: 5, operator: '王强', type: 'login', module: 'system', description: '用户登录系统', target: '账号: wangqiang', operationTime: '2026-06-12 11:00:00', ip: '192.168.1.102', status: 'success', detail: '用户通过用户名密码登录', params: '{username: "wangqiang"}' },
        { id: 6, operator: '王强', type: 'query', module: 'data_decision', description: '查看数据报表', target: '日报表', operationTime: '2026-06-12 11:15:00', ip: '192.168.1.102', status: 'success', detail: '查看今日数据汇总报表', params: '{date: "2026-06-12"}' },
        { id: 7, operator: '张伟', type: 'remove', module: 'sentiment_monitor', description: '删除舆情记录', target: '舆情ID: 10086', operationTime: '2026-06-12 12:00:00', ip: '192.168.1.100', status: 'success', detail: '成功删除过期舆情数据', params: '{days: 30}', beforeData: '舆情ID：10086\n状态：已过期\n创建时间：2026-05-13', afterData: '记录已删除' },
        { id: 8, operator: '赵明', type: 'login', module: 'system', description: '用户登录系统', target: '账号: zhaoming', operationTime: '2026-06-12 14:00:00', ip: '192.168.1.103', status: 'success', detail: '外部访客登录', params: '{username: "zhaoming"}' },
        { id: 9, operator: '赵明', type: 'query', module: 'video_monitor', description: '查看监控视频', target: '实时监控', operationTime: '2026-06-12 14:05:00', ip: '192.168.1.103', status: 'success', detail: '查看景区实时监控画面', params: '{}' },
        { id: 10, operator: '张伟', type: 'export', module: 'customer_analysis', description: '导出客群数据', target: '客群画像分析', operationTime: '2026-06-12 15:00:00', ip: '192.168.1.100', status: 'success', detail: '导出Excel格式文件', params: '{format: "excel"}' },
        { id: 11, operator: '李丽', type: 'modify', module: 'user_manage', description: '修改用户信息', target: '用户: 王强', operationTime: '2026-06-12 15:30:00', ip: '192.168.1.101', status: 'success', detail: '更新用户联系方式', params: '{userId: 3, phone: "13800138003"}', beforeData: '手机号：13800138002\n邮箱：wangqiang@test.com', afterData: '手机号：13800138003\n邮箱：wangqiang@test.com' },
        { id: 12, operator: '张伟', type: 'logout', module: 'system', description: '用户退出系统', target: '账号: zhangwei', operationTime: '2026-06-12 18:00:00', ip: '192.168.1.100', status: 'success', detail: '用户主动退出登录', params: '{}' },
        { id: 13, operator: '陈悦', type: 'import', module: 'price_supervision', description: '批量导入价格数据', target: '价格数据文件', operationTime: '2026-06-12 16:00:00', ip: '192.168.1.104', status: 'success', detail: '成功导入50条价格记录', params: '{count: 50}', beforeData: '数据总量：1200条', afterData: '数据总量：1250条' },
        { id: 14, operator: '李华', type: 'login', module: 'system', description: '用户登录系统', target: '账号: lihua', operationTime: '2026-06-12 09:00:00', ip: '192.168.1.105', status: 'failed', detail: '密码错误，登录失败', params: '{username: "lihua"}' },
        { id: 15, operator: '李华', type: 'login', module: 'system', description: '用户登录系统', target: '账号: lihua', operationTime: '2026-06-12 09:02:00', ip: '192.168.1.105', status: 'success', detail: '用户通过用户名密码登录', params: '{username: "lihua"}' },
        { id: 16, operator: '张伟', type: 'modify', module: 'log', description: '修改系统配置', target: '系统日志', operationTime: '2026-06-12 11:00:00', ip: '192.168.1.100', status: 'success', detail: '更新系统基础配置参数', params: '{timeout: 300}', beforeData: '超时时间：180秒\n最大上传：10MB', afterData: '超时时间：300秒\n最大上传：10MB' }
      ],
      typeLabels: {
        login: '登录',
        logout: '退出',
        create: '新建',
        modify: '修改',
        remove: '删除',
        query: '查询',
        export: '导出',
        import: '导入'
      },
      moduleLabels: {
        bigdata_home: '大数据首页',
        data_decision: '数据决策中心',
        price_supervision: '价格动态监管',
        sentiment_monitor: '全网舆情监测',
        customer_analysis: '客群画像分析',
        business_resource: '业态资源统筹',
        video_monitor: '视频监测管理',
        capacity_monitor: '承载力监测',
        user_manage: '用户管理',
        role: '角色配置',
        log: '系统日志',
        system: '系统操作'
      }
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalLogs / 10)
    },
    filteredLogs() {
      let result = this.logs
      
      if (this.searchForm.type) {
        result = result.filter(log => log.type === this.searchForm.type)
      }
      if (this.searchForm.operator) {
        result = result.filter(log => log.operator.toLowerCase().includes(this.searchForm.operator.toLowerCase()))
      }
      if (this.searchForm.module) {
        result = result.filter(log => log.module === this.searchForm.module)
      }
      if (this.searchForm.startTime) {
        result = result.filter(log => log.operationTime >= this.searchForm.startTime.replace('T', ' '))
      }
      if (this.searchForm.endTime) {
        result = result.filter(log => log.operationTime <= this.searchForm.endTime.replace('T', ' '))
      }
      
      return result
    }
  },
  mounted() {
    this.totalLogs = this.logs.length
  },
  methods: {
    getTypeLabel(type) {
      return this.typeLabels[type] || type
    },
    getModuleLabel(module) {
      return this.moduleLabels[module] || module
    },
    searchLogs() {
      this.currentPage = 1
      this.totalLogs = this.filteredLogs.length
    },
    resetSearch() {
      this.searchForm = {
        startTime: '',
        endTime: '',
        type: '',
        operator: '',
        module: ''
      }
      this.currentPage = 1
      this.totalLogs = this.logs.length
    },
    showLogDetail(log) {
      this.selectedLog = log
      this.showDetailModal = true
    },
    closeDetailModal() {
      this.showDetailModal = false
      this.selectedLog = null
    }
  }
}
</script>

<style scoped>
.log-container {
  --ui-bg: #f5f7fa;
  --ui-surface: #ffffff;
  --ui-surface-soft: #f9fafc;
  --ui-border: #dcdfe6;
  --ui-border-soft: #ebeef5;
  --ui-text: #1f2937;
  --ui-text-regular: #606266;
  --ui-primary: #409eff;
  --ui-success: #67c23a;
  --ui-danger: #f56c6c;
  --ui-warning: #e6a23c;
  --ui-radius: 8px;
  --ui-shadow: 0 8px 24px rgba(31, 45, 61, 0.08);
  
  min-height: calc(100vh - 54px);
  background: var(--ui-bg);
  padding: 24px;
  box-sizing: border-box;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  padding-bottom: 14px;
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-icon {
  font-size: 24px;
}

.panel-title h2 {
  margin: 0;
  color: var(--ui-text);
  font-size: 20px;
}

.search-container {
  /* background: rgba(255, 255, 255, 0.96); */
  /* border: 1px solid var(--ui-border-soft);
  border-radius: var(--ui-radius);
  box-shadow: var(--ui-shadow);
  padding: 16px 20px; */
  margin-bottom: 20px;
}

.search-row {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.search-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-label {
  color: var(--ui-text-regular);
  font-size: 13px;
}

.search-input {
  padding: 8px 12px;
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: 6px;
  color: var(--ui-text);
  font-size: 13px;
}

.search-separator {
  color: var(--ui-text-regular);
}

.search-select {
  padding: 8px 12px;
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: 6px;
  color: var(--ui-text);
  font-size: 13px;
}

.search-actions {
  display: flex;
  gap: 12px;
  margin-left: auto;
}

.btn-search {
  min-height: 32px;
  padding: 0 14px;
  background: #ecf5ff;
  border: 1px solid #b3d8ff;
  border-radius: 6px;
  color: #1d4f91;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: none;
}

.btn-search:hover {
  background: rgba(64, 158, 255, 0.15);
}

.btn-reset {
  min-height: 32px;
  padding: 0 14px;
  background: var(--ui-surface-soft);
  border: 1px solid var(--ui-border);
  border-radius: 6px;
  color: var(--ui-text-regular);
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: none;
}

.btn-reset:hover {
  background: rgba(0, 0, 0, 0.05);
}

.table-container {
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid var(--ui-border-soft);
  border-radius: var(--ui-radius);
  box-shadow: var(--ui-shadow);
  overflow: hidden;
  padding: 18px;
  box-sizing: border-box;
}

.table-container * {
  text-shadow: none;
}

.table-container,
.table-container p,
.table-container span,
.table-container div {
  color: var(--ui-text-regular, #606266);
}

.data-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.data-table th,
.data-table td {
  min-height: 36px;
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid var(--ui-border-soft, #ebeef5);
}

.data-table tr:last-child td {
  border-bottom: 0;
}

.data-table th {
  background: var(--ui-surface-soft);
  color: var(--ui-text);
  font-weight: 600;
  font-size: 13px;
}

.data-table tbody tr:hover {
  background: #ecf5ff;
}

.data-table td {
  color: var(--ui-text);
  font-size: 13px;
}

.type-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid transparent;
}

.type-badge.login {
  background: #ecf5ff;
  color: var(--ui-primary);
  border-color: #b3d8ff;
}

.type-badge.logout {
  background: #fdf6ec;
  color: var(--ui-warning);
  border-color: #f5dab1;
}

.type-badge.create {
  background: #f0f9eb;
  color: var(--ui-success);
  border-color: #e1f3d8;
}

.type-badge.modify {
  background: #ecf5ff;
  color: var(--ui-primary);
  border-color: #b3d8ff;
}

.type-badge.remove {
  background: #fef0f0;
  color: var(--ui-danger);
  border-color: #fde2e2;
}

.type-badge.query {
  background: #f3e8ff;
  color: #9b59b6;
  border-color: #e9d5ff;
}

.type-badge.export {
  background: #fdf6ec;
  color: var(--ui-warning);
  border-color: #f5dab1;
}

.type-badge.import {
  background: #e8f5e9;
  color: var(--ui-success);
  border-color: #c8e6c9;
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid transparent;
}

.status-success {
  background: #f0f9eb;
  color: var(--ui-success);
  border-color: #e1f3d8;
}

.status-failed {
  background: #fef0f0;
  color: var(--ui-danger);
  border-color: #fde2e2;
}

.btn-detail {
  min-height: 28px;
  padding: 0 12px;
  background: var(--ui-surface-soft);
  border: 1px solid var(--ui-border);
  border-radius: 4px;
  color: var(--ui-primary);
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: none;
}

.btn-detail:hover {
  background: rgba(64, 158, 255, 0.1);
}

.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding: 12px 20px;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid var(--ui-border-soft);
  border-radius: var(--ui-radius);
  box-shadow: var(--ui-shadow);
}

.pagination-info {
  color: var(--ui-text-regular);
  font-size: 13px;
}

.pagination-buttons {
  display: flex;
  align-items: center;
  gap: 16px;
}

.btn-page {
  min-height: 32px;
  padding: 0 14px;
  background: var(--ui-surface-soft);
  border: 1px solid var(--ui-border);
  border-radius: 6px;
  color: var(--ui-primary);
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: none;
}

.btn-page:hover:not(:disabled) {
  background: rgba(64, 158, 255, 0.1);
}

.btn-page:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-number {
  color: var(--ui-text-regular);
  font-size: 13px;
}

/* 弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(31, 45, 61, 0.28);
  z-index: 1000;
}

.modal-content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid var(--ui-border-soft);
  border-radius: var(--ui-radius);
  box-shadow: var(--ui-shadow);
  z-index: 1001;
  width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 18px;
  box-sizing: border-box;
}

.modal-content * {
  text-shadow: none;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid var(--ui-border-soft);
}

.modal-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--ui-text);
}

.modal-close {
  width: 32px;
  height: 32px;
  border: 1px solid var(--ui-border);
  background: var(--ui-surface-soft);
  color: var(--ui-text-regular);
  font-size: 20px;
  cursor: pointer;
  border-radius: 6px;
  transition: background 0.2s;
  box-shadow: none;
}

.modal-close:hover {
  background: rgba(0, 0, 0, 0.05);
}

.modal-body {
  padding: 20px 0;
}

.detail-info {
  padding: 10px;
}

.detail-row {
  display: flex;
  padding: 10px 0;
  border-bottom: 1px dashed var(--ui-border-soft);
}

.detail-row:last-child {
  border-bottom: 0;
}

.detail-label {
  width: 120px;
  color: var(--ui-text-regular);
  font-size: 13px;
}

.detail-value {
  flex: 1;
  color: var(--ui-text);
  font-size: 13px;
  word-break: break-all;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.btn-confirm {
  min-height: 32px;
  padding: 0 14px;
  background: #ecf5ff;
  border: 1px solid #b3d8ff;
  border-radius: 6px;
  color: #1d4f91;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: none;
}

.btn-confirm:hover {
  background: rgba(64, 158, 255, 0.15);
}

/* 操作前后对比样式 */
.compare-section {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid var(--ui-border-soft);
}

.compare-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--ui-text);
  margin-bottom: 16px;
}

.compare-container {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.compare-column {
  flex: 1;
}

.compare-header {
  padding: 8px 12px;
  background: var(--ui-surface-soft);
  border-radius: 6px 6px 0 0;
  font-size: 13px;
  font-weight: 500;
  color: var(--ui-text);
  border: 1px solid var(--ui-border-soft);
  border-bottom: none;
}

.compare-content {
  padding: 12px;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid var(--ui-border-soft);
  border-radius: 0 0 6px 6px;
  font-size: 12px;
  color: var(--ui-text-regular);
  word-break: break-all;
  max-height: 150px;
  overflow-y: auto;
  white-space: pre-wrap;
}

.compare-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  font-size: 20px;
  color: var(--ui-primary);
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/pages/log.vue